import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import Home from "./pages/Home";
import MultiSig from "./pages/MultiSig";
import Execute from "./pages/Execute";

export default function AppRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/multisig" element={<MultiSig />} />
        <Route path="/execute" element={<Execute />} />
      </Routes>
    </Router>
  )
}